import moment from "moment";
import { AssistantPermission } from "../interfaces";

export const urlWithFormat = (url: string | undefined): string | undefined => {
  return url
    ? url.split('"').reduce((result, item) => {
        return `${result}${item}`;
      }, "")
    : url;
};

export const safeFormatNumber = (value?: any) => {
  try {
    if (value == 0) return "0";
    if (value === null || value == "" || value === undefined) return "";

    const isNumber = !isNaN(Number(value.toString()));
    if (!isNumber) return `${value}`;
    const nValue = Number(value);
    return nValue > 9999 ? kFormatter(nValue) : nValue;
  } catch (e) {
    return `${value}`;
  }
};

export function kFormatter(amount?: number): string {
  if (amount === undefined || amount === 0) {
    return "--";
  }
  const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
  const tier = (Math.log10(amount) / 3) | 0;
  if (tier === 0) {
    return `${amount}`;
  }

  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = amount / scale;
  return Number(scaled.toFixed(1)) + suffix;
}

export function UIDate(date: string): string {
  return moment(date).format("MM/DD/YYYY") === "Invalid date" ? date : moment(date).format("MM/DD/YYYY");
}

export function capitalizeFormatter(text: string): string {
  const capitalizedText = text.toLocaleLowerCase();
  return capitalizedText.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
}

export function toAssistantPermissions(permissions: any): AssistantPermission[] {
  return Object.keys(permissions).map(componentId => {
    return {
      componentId: componentId,
      level: permissions[componentId],
    };
  });
}

export function noSpaces(word?: string): string {
  if (!word) {
    return "";
  }
  return word.replace(/\s/g, "");
}

export function removeSpecialCharacters(word?: string): string {
  if (!word) {
    return "";
  }
  return noSpaces(word).replace(/[^\w]/gi, "").replace(/-/g, "").replace(/_/g, "");
}

export async function manageWebAddress(webAddressCheck?: string): Promise<string> {
  if (!webAddressCheck) {
    return "";
  }
  if (/^http:\/\//i.test(webAddressCheck)) {
    return webAddressCheck.replace(/^http:\/\//i, "https://");
  } else if (/^https:\/\//i.test(webAddressCheck)) {
    return webAddressCheck;
  }
  return `https://${webAddressCheck}`;
}

export function formatHexColor(input: string | null | undefined): string | null {
  const hexString = input?.trim();
  if (!hexString) {
    return null;
  }

  let cleanHex = hexString.startsWith("#") ? hexString.slice(1) : hexString;

  // Use a regex to validate the hex string format (3, 4, 6, or 8 hex characters)
  if (!/^[0-9a-fA-F]{3,4}$|^[0-9a-fA-F]{6}$|^[0-9a-fA-F]{8}$/.test(cleanHex)) {
    return null;
  }

  // Handle shorthand hex (e.g., "F0C" -> "FF00CC")
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split("")
      .map(char => char + char)
      .join("");
  } else if (cleanHex.length === 4) {
    cleanHex = cleanHex
      .slice(0, 3)
      .split("")
      .map(char => char + char)
      .join("");
  }

  // If the hex string has an alpha channel (8 characters), slice it off.
  if (cleanHex.length === 8) {
    cleanHex = cleanHex.slice(0, 6);
  }

  // Return the 6-digit hex code with a leading '#'.
  return `#${cleanHex.toUpperCase()}`;
}
